// extracted by mini-css-extract-plugin
export default {"container":"container--aNeMzJuVPydGb1l","block":"block--g_0BnfsV5o3Z2RL","header":"header--wrVoxTL3fcurnDC"};